import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-algoritmo-rilettura',
  templateUrl: './algoritmo-rilettura.component.html',
  styleUrls: ['./algoritmo-rilettura.component.css']
})
export class AlgoritmoRiletturaComponent implements OnInit {
  public from = 4;
  public to = 10;
  public minimumInterval = 3;
  public maxStarlings = 30.00;
  public bonus1from = 0;
  public bonus1to = 10.00;
  public bonus1step = 1;
  public bonus2from = 10.00;
  public bonus2to = 20.00;
  public bonus2step = 2;
  public bonus3from = 30.00;
  public bonus3to = 40.00;
  public bonus3step = 3;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/algoritmo-rilettura/algoritmo-rilettura.component.ts